import request from '@/utils/request'

// 查询列表
export function apiMdmUomUnitsOfMeasureList (query) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apitSysCompanySubjectNewExport (data) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure/v2/export',
    method: 'post',
    data: data
  })
}

// 单位
export function apiMdmUomUnitsOfMeasureUnitOfMeasureList (query) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure/unitOfMeasureList',
    method: 'get',
    params: query
  })
}

// 新增
export function apiMdmUomUnitsOfMeasureAdd (data) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmUomUnitsOfMeasureUpdate (data) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure',
    method: 'put',
    data: data
  })
}
